module.exports = __webpack_public_path__ + "static/media/share-all.6fca90c4.svg";